import ExceptionBase from "@/dto/exceptions/exceptionBase";
export default class NotFoundValidationException extends ExceptionBase {
  constructor(data) {
    super(data);
  }
}
